import * as React from 'react';
import cn from 'classnames';
import { isSameDay, isToday } from 'date-fns';
import { useDay } from '@datepicker-react/hooks';
import { DatePickerContext } from './context';
import { datePickerClasses } from './date-picker';
export var Day = function Day(props) {
  var _React$useContext = React.useContext(DatePickerContext),
    focusedDate = _React$useContext.focusedDate,
    isDateFocused = _React$useContext.isDateFocused,
    isDateSelected = _React$useContext.isDateSelected,
    isDateHovered = _React$useContext.isDateHovered,
    isDateBlocked = _React$useContext.isDateBlocked,
    isFirstOrLastSelectedDate = _React$useContext.isFirstOrLastSelectedDate,
    onDateSelect = _React$useContext.onDateSelect,
    onDateFocus = _React$useContext.onDateFocus,
    onDateHover = _React$useContext.onDateHover,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate;
  var dayRef = React.useRef(null);
  var _useDay = useDay({
      focusedDate: focusedDate,
      isDateFocused: isDateFocused,
      isDateSelected: isDateSelected,
      isDateHovered: isDateHovered,
      isDateBlocked: isDateBlocked,
      isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
      onDateFocus: onDateFocus,
      onDateSelect: onDateSelect,
      onDateHover: onDateHover,
      dayRef: dayRef,
      date: props.date
    }),
    isSelected = _useDay.isSelected,
    isSelectedStartOrEnd = _useDay.isSelectedStartOrEnd,
    isWithinHoverRange = _useDay.isWithinHoverRange,
    disabledDate = _useDay.disabledDate,
    onClick = _useDay.onClick,
    onKeyDown = _useDay.onKeyDown,
    onMouseEnter = _useDay.onMouseEnter,
    tabIndex = _useDay.tabIndex;
  var handleKeyDown = function handleKeyDown(e) {
    return onKeyDown(e.nativeEvent);
  };
  var isStartDate = !!startDate && isSameDay(props.date, startDate);
  var isEndDate = !!endDate && isSameDay(props.date, endDate);
  var isCurrentDay = isToday(props.date);
  var classNames = cn(datePickerClasses.DAY, {
    '-selected': isSelected,
    '-selected-cap': isSelectedStartOrEnd,
    '-disabled': disabledDate,
    '-range': isWithinHoverRange,
    '-start-date': isStartDate,
    '-end-date': isEndDate,
    '-today': isCurrentDay
  });
  return React.createElement("button", {
    className: classNames,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onMouseEnter: onMouseEnter,
    tabIndex: tabIndex,
    type: "button",
    ref: dayRef
  }, props.label);
};